import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useStore } from "hooks/use-store";
import { useWeather } from "hooks/use-weather";
import { Block } from "components/ui/block";
import { ScrollButtons } from "components/ui/scroll-buttons";
import { PLACEHOLDER } from "utils/constants";

export const InfoScreen = () => {
  const { t } = useTranslation("translation", { keyPrefix: "trip_info" });
  const weather = useWeather();
  const duration = useStore((state) => state.duration);
  const distance = useStore((state) => state.distance);

  const ref = useRef<HTMLDivElement>(null);

  return (
    <section
      ref={ref}
      className="h-full overflow-auto flex flex-wrap w-full p-1"
    >
      <Block
        header={t("duration.title")}
        value={duration}
        className="w-full sm:w-[calc(50%-0.5rem)] lg:w-[calc(33.3%-0.5rem)] m-1"
      />
      <Block
        header={t("distance.title")}
        value={distance}
        footer={t("distance.description")}
        className="w-full sm:w-[calc(50%-0.5rem)] lg:w-[calc(33.3%-0.5rem)] m-1"
      />
      <Block
        header={t("sea_state.title")}
        value={weather?.data?.sea_state?.value ?? PLACEHOLDER}
        footer={t("sea_state.description")}
        className="w-full sm:w-[calc(50%-0.5rem)] lg:w-[calc(33.3%-0.5rem)] m-1"
      />
      <Block
        header={t("wind_speed.title")}
        value={weather?.data?.wind_speed?.value ?? PLACEHOLDER}
        footer={t("wind_speed.description")}
        className="w-full sm:w-[calc(50%-0.5rem)] lg:w-[calc(33.3%-0.5rem)] m-1"
      />
      <Block
        header={t("wind_direction.title")}
        value={weather?.data?.wind_direction?.value ?? PLACEHOLDER}
        className="w-full sm:w-[calc(50%-0.5rem)] lg:w-[calc(33.3%-0.5rem)] m-1"
      />
      <Block
        header={t("temperature.title")}
        value={weather?.data?.air_temperature?.value ?? PLACEHOLDER}
        footer={t("temperature.description")}
        className="w-full sm:w-[calc(50%-0.5rem)] lg:w-[calc(33.3%-0.5rem)] m-1"
      />
      <ScrollButtons containerRef={ref} className="absolute bottom-4 right-4" />
    </section>
  );
};
